(function () {
  'use strict';
  if (window.__bfDesktopTopLoaded) return;
  window.__bfDesktopTopLoaded = true;
  var desktop = window.matchMedia('(min-width: 768px)');
  function motion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
  function preservePageScroll(action) {
    var x = window.scrollX, y = window.scrollY;
    action();
    if (window.scrollX !== x || window.scrollY !== y) window.scrollTo({ left: x, top: y, behavior: 'instant' });
  }
  function navigate(target) {
    var bar = document.querySelector('.bf-pc-nav__bar');
    window.scrollTo({ top: Math.max(0,window.scrollY + target.getBoundingClientRect().top - (bar ? bar.offsetHeight : 0)), behavior: motion() });
  }
  function initNav(root) {
    if (root.dataset.bfPcNavInit) return;
    root.dataset.bfPcNavInit = 'true';
    var bar = root.querySelector('.bf-pc-nav__bar');
    var links = Array.from(root.querySelectorAll('[data-bf-pc-nav-target]'));
    function update() {
      if (!root.isConnected) return;
      root.classList.toggle('is-stuck',desktop.matches && root.getBoundingClientRect().top <= 0);
      if (!desktop.matches) return;
      var active = links[0];
      var activeTop = -Infinity;
      var atBottom = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2;
      links.forEach(function (link) {
        var section = document.getElementById(link.dataset.bfPcNavTarget);
        if (!section) return;
        var top = section.getBoundingClientRect().top;
        if ((top <= bar.offsetHeight + 8 || (atBottom && top < window.innerHeight)) && top > activeTop) { active = link; activeTop = top; }
      });
      links.forEach(function (link) { link.classList.toggle('is-active',link === active); if (link === active) link.setAttribute('aria-current','location'); else link.removeAttribute('aria-current'); });
    }
    links.forEach(function (link) { link.addEventListener('click',function (event) { var target = document.getElementById(link.dataset.bfPcNavTarget); if (!target) return; event.preventDefault(); navigate(target); }); });
    var buy = root.querySelector('.bf-pc-nav__buy');
    if (buy && !buy.hasAttribute('data-bf-notify-disabled')) buy.addEventListener('click',function (event) {
      event.preventDefault();
      var target = document.getElementById('bf-aura');
      if (target) navigate(target);
    });
    window.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update);
    update();
  }
  function initCalendar(root) {
    if (root.dataset.bfPcCalendarInit) return;
    root.dataset.bfPcCalendarInit = 'true';
    var section = root.closest('.bf-root');
    var year = Number(root.dataset.bfPcCalendarYear) || 2026;
    var grid = root.querySelector('[data-bf-pc-calendar-dates]');
    var tabs = Array.from(root.querySelectorAll('[data-bf-pc-month]'));
    var entries = Array.from(section.querySelectorAll('[data-bf-giveaway]'));
    var dialog = root.querySelector('dialog');
    var lastFocus;
    var sceneSource = root.querySelector('[data-bf-pc-calendar-month-picture] source');
    var baseSource = root.querySelector('[data-bf-pc-calendar-picture] source');
    var octoberSource = root.getAttribute('data-bf-scene-10') || baseSource.getAttribute('srcset');
    var idleIcons = Array.from(root.querySelectorAll('.bf-pc-calendar__icon--idle')).map(function (icon) { var source = icon.parentElement.querySelector('source'); return { source: source, gold: source.getAttribute('srcset') }; });
    function highlighted(month, day) {
      if (month === 10 && (day === 20 || day === 27)) return true;
      if (year === 2026 && month === 11 && (day === 3 || day === 10 || day === 17 || day === 20 || (day >= 23 && day <= 30))) return true;
      return false;
    }
    function fillConfetti(layer) { if (window.BFCalendarConfetti) window.BFCalendarConfetti.start(layer); }
    function openDialog(modal) {
      var modalNow = typeof dialog.matches === 'function' && dialog.matches(':modal');
      if (dialog.open && modalNow && typeof dialog.close === 'function') dialog.close();
      if (dialog.open && modal && !modalNow && typeof dialog.close === 'function') dialog.close();
      preservePageScroll(function () {
        if (!dialog.open) {
          if (modal && typeof dialog.showModal === 'function') dialog.showModal();
          else if (typeof dialog.show === 'function') dialog.show();
          else dialog.setAttribute('open', '');
        }
      });
    }
    function show(title, content) {
      lastFocus = document.activeElement;
      if (window.BFCalendarConfetti) window.BFCalendarConfetti.stop(root.querySelector('[data-bf-confetti]'));
      dialog.classList.remove('is-prize', 'is-pre-prize');
      idleIcons.forEach(function (icon) { icon.source.setAttribute('srcset', root.dataset.bfWhiteIcon); });
      root.querySelector('[data-bf-prize]').hidden = true;
      root.querySelector('[data-bf-confetti]').hidden = true;
      root.querySelector('[data-bf-howto]').hidden = false;
      root.querySelector('[data-bf-pc-calendar-dialog-title]').textContent = title;
      var body = root.querySelector('[data-bf-pc-calendar-dialog-content]');
      body.replaceChildren();
      Array.from(content.childNodes).forEach(function (child) { body.appendChild(child.cloneNode(true)); });
      openDialog(true);
    }
    function openPrize(month, day) {
      lastFocus = document.activeElement;
      if (root.hasAttribute('data-bf-prelaunch')) { preservePageScroll(function () { window.BFPreCalendar.show(root, year, month, day); }); return; }
      dialog.classList.add('is-prize');
      root.querySelector('[data-bf-howto]').hidden = true;
      root.querySelector('[data-bf-prize]').hidden = false;
      root.querySelector('[data-bf-prize-range]').textContent = month === 11 ? (root.dataset.bfRange11 || '11.3-11.30') : (root.dataset.bfRange10 || '10.1-10.27');
      var layer = root.querySelector('[data-bf-confetti]');
      layer.hidden = false;
      fillConfetti(layer);
      openDialog(false);
      idleIcons.forEach(function (icon) { icon.source.setAttribute('srcset', root.dataset.bfWhiteIcon); });
    }
    function render(month) {
      var novemberArt = root.hasAttribute('data-bf-revealed-third-week') && month === 11;
      root.classList.toggle('is-nov3-calendar', novemberArt);
      baseSource.setAttribute('srcset', novemberArt ? root.getAttribute('data-bf-scene-11') : octoberSource);
      root.dataset.bfPcMonth = String(month);
      if (month !== 10) sceneSource.setAttribute('srcset', root.getAttribute('data-bf-scene-' + month));
      idleIcons.forEach(function (icon) { icon.source.setAttribute('srcset', root.dataset.bfWhiteIcon); });
      var tab = tabs.find(function (item) { return Number(item.dataset.bfPcMonth) === month; });
      tabs.forEach(function (item) { var active = item === tab; item.classList.toggle('is-active',active); item.setAttribute('aria-selected',String(active)); item.tabIndex = active ? 0 : -1; });
      grid.replaceChildren();
      grid.classList.toggle('is-alternate', month === 11);
      grid.classList.toggle('is-mystery', month === 12);
      grid.setAttribute('aria-label',tab.querySelector('span').textContent + ' giveaway dates');
      ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].forEach(function (day) { var item = document.createElement('span'); item.className = 'bf-pc-calendar__weekday'; item.textContent = day; grid.appendChild(item); });
      var start = (new Date(year,month - 1,1).getDay() + 6) % 7;
      var count = new Date(year,month,0).getDate();
      var firstDay = year === 2026 && month === 11 ? 2 : 1;
      if (firstDay === 2) start = 0;
      var rows = Math.ceil((start + count - firstDay + 1) / 7);
      grid.style.gridTemplateRows = 'calc(26 * var(--bf-pc-s)) repeat(' + rows + ',1fr)';
      for (var cell = 0; cell < rows * 7; cell++) {
        var day = cell - start + firstDay;
        var date = year + '-' + String(month).padStart(2,'0') + '-' + String(day).padStart(2,'0');
        var entry = entries.find(function (item) { return item.dataset.bfGiveaway === date; });
        var inMonth = day > 0 && day <= count;
        var mystery = month === 12;
        var giveaway = inMonth && !mystery && (!!entry || highlighted(month, day));
        var item = document.createElement(giveaway ? 'button' : 'span');
        item.className = 'bf-pc-calendar__day' + (giveaway ? ' is-giveaway' : '') + (month === 10 && day === 20 ? ' is-featured' : '');
        if (mystery && inMonth) { item.textContent = '?'; item.setAttribute('aria-hidden', 'true'); }
        else if (inMonth) { item.textContent = day; item.setAttribute('aria-label',tab.querySelector('span').textContent + ' ' + day + ', ' + year + (giveaway ? ' giveaway details' : '')); }
        if (item.tagName === 'BUTTON') {
          item.type = 'button';
          (function (node, eventEntry, eventMonth, eventDay) { node.addEventListener('click',function () { if (!root.hasAttribute('data-bf-prelaunch') && eventEntry && (eventEntry.textContent.trim() || eventEntry.querySelector('img'))) show(eventEntry.dataset.bfGiveawayTitle, eventEntry); else openPrize(eventMonth, eventDay); }); })(item, entry, month, day);
        }
        if (giveaway) { var ripple = document.createElement('span'); ripple.className = 'bf-date-ripple'; ripple.setAttribute('aria-hidden','true'); item.appendChild(ripple); }
        grid.appendChild(item);
      }
    }
    tabs.forEach(function (tab,index) {
      tab.addEventListener('click',function () { render(Number(tab.dataset.bfPcMonth)); });
      tab.addEventListener('keydown',function (event) { var next = event.key === 'ArrowRight' ? (index + 1) % tabs.length : event.key === 'ArrowLeft' ? (index + tabs.length - 1) % tabs.length : event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : -1; if (next < 0) return; event.preventDefault(); tabs[next].focus(); tabs[next].click(); });
    });
    root.querySelector('[data-bf-pc-calendar-how]').addEventListener('click',function () { show('How to Win',section.querySelector('[data-bf-giveaway-instructions]')); });
    root.querySelectorAll('[data-bf-pc-calendar-close]').forEach(function (button) { button.addEventListener('click',function () { if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open'); }); });
    dialog.addEventListener('close',function () { idleIcons.forEach(function (icon) { icon.source.setAttribute('srcset', root.dataset.bfWhiteIcon); }); if (lastFocus && lastFocus.isConnected) lastFocus.focus({ preventScroll: true }); });
    dialog.addEventListener('click',function (event) { if (event.target === dialog) { var box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
    function onDesktopChange() { if (!desktop.matches && dialog.open) dialog.close(); }
    if (desktop.addEventListener) desktop.addEventListener('change',onDesktopChange);
    else if (desktop.addListener) desktop.addListener(onDesktopChange);
    render(Number(root.dataset.bfInitialMonth) || 10);
  }
  function init(root) { root.querySelectorAll('[data-bf-pc-nav]').forEach(initNav); root.querySelectorAll('[data-bf-pc-calendar]').forEach(initCalendar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load',function (event) { init(event.target); });
})();
